import { Nullable } from 'buzz_lib_building_blocks';

export const ensure: <T>(value: Nullable<T> | undefined, errorMessage?: string) => asserts value is T = <T>(
  value: Nullable<T>,
  errorMessage?: string
): asserts value is T => {
  if (value === undefined || value === null) {
    throw Error(errorMessage ?? 'Value is missing.');
  }
};
